// Lopez Appliances - i18n dictionary (EN / ES)
// Every user-facing string flows through this file.

export const translations = {
  en: {
    loading: {
      slogan: "Family Trusted Since 1985 — Repairs Done Right.",
    },
    nav: {
      services: "Services",
      reviews: "Reviews",
      hours: "Hours",
      location: "Location",
      contact: "Contact",
    },
    hero: {
      badge: "Family Owned Since 1985",
      title: "Lopez Appliances",
      subtitle:
        "Refrigeration • Coolers • Stoves • Ovens — Repaired by Experts.",
      cta_call: "Call Now: (415) 826-8922",
      cta_quote: "Get a Quote",
      scroll: "Scroll",
    },
    services: {
      overline: "What We Repair",
      title: "Our Services",
      subtitle:
        "Four decades of expertise across every appliance that keeps your home running.",
      fridge: {
        title: "Refrigerator Repair",
        desc: "Compressor, thermostat, defrost, and ice-maker fixes — same-day diagnostics on most models.",
      },
      cooler: {
        title: "Cooler Repair",
        desc: "Wine fridges, beverage coolers, and walk-in units — sealed-system specialists.",
      },
      stove: {
        title: "Stove Repair",
        desc: "Gas and electric stoves — burners, igniters, and control boards rebuilt with precision.",
      },
      oven: {
        title: "Oven Repair",
        desc: "Heating elements, sensors, and door seals restored to factory performance.",
      },
      used: {
        title: "Used Appliances for Sale",
        desc: "Hand-picked, fully-tested appliances at honest prices — browse our OfferUp store.",
        cta: "Shop on OfferUp",
      },
    },
    hours: {
      overline: "When We Work",
      title: "Business Hours",
      open_now: "Open Now",
      closed_now: "Closed",
      weekdays: "Monday – Saturday",
      sunday: "Sunday",
      time_weekdays: "9:00 AM – 5:00 PM",
      time_sunday: "Closed",
      days: {
        Mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
        Sun: "Sunday",
      },
      footnote: "Same-day service available across San Francisco.",
    },
    reviews: {
      overline: "What Customers Say",
      title: "Google Reviews",
      summary: "8 reviews • 4.4 ★★★★½",
      cta: "Leave a Review",
      list: [
        {
          name: "Willie G. Morris",
          stars: 5,
          text: "San Francisco Heating & Air Conditioning Contractors is excellent. Their technician was knowledgeable, friendly, and efficient. He diagnosed the issue quickly and fixed it the same day. I appreciated the honesty and clear communication. The price was very fair. Truly delivers reliable service, and I'll be calling them again for sure.",
        },
        {
          name: "Luis P. Perez",
          tag: "Local Guide",
          stars: 5,
          text: "I only tend to write reviews when I either have a bad experience or a great one, and this is the latter. I cannot recommend Ethan enough for HVAC units in condo buildings, he's even insightful in Nest thermostats. I love working with them.",
        },
        {
          name: "Riley Allen",
          stars: 5,
          text: "The technician provided outstanding customer service. He patiently answered all our questions and ensured we understood the repair process. A truly pleasant and reassuring experience!",
        },
        {
          name: "Mike Bradford",
          stars: 5,
          text: "Our HVAC unit at our coworking space went out during a hot spell and they came out right away. We have had them out a few times to fix some other issues and have always given us a straight answer and completed the work timely!",
        },
      ],
    },
    location: {
      overline: "Find Us",
      title: "Our Location",
      address: "3474 Mission Street, San Francisco, CA 94110",
      phone: "(415) 826-8922",
      email: "lopezappliance85@gmail.com",
      cta: "Get Directions",
    },
    offerup: {
      overline: "Pre-Owned, Fully Tested",
      title: "Shop Our Used Appliances",
      desc: "Quality refurbished refrigerators, washers, and dryers — inspected by our team and listed at fair, neighborly prices on OfferUp.",
      cta: "View on OfferUp",
    },
    about: {
      overline: "Our Story",
      title: "Family Owned Since 1985.",
      desc: "Four decades of fixing what matters in San Francisco homes — built on honesty, craftsmanship, and neighborly service.",
      counter_years: "40+ Years",
      counter_repairs: "1000s of Repairs",
      counter_rating: "5★ Rated",
    },
    footer: {
      slogan: "Family Trusted Since 1985.",
      quick_links: "Quick Links",
      contact: "Contact",
      follow: "Follow",
      copyright: "© 2026 Lopez Appliances. Family Owned Since 1985.",
    },
    quote_email: {
      subject: "Quote Request - Lopez Appliances",
      body: "Hi Lopez Appliances,\n\nI'd like a quote for [appliance type].\nMy issue is: [describe].\nBest contact: [phone/email].\n\nThank you!",
    },
  },
  es: {
    loading: {
      slogan: "Confianza Familiar Desde 1985 — Reparaciones Bien Hechas.",
    },
    nav: {
      services: "Servicios",
      reviews: "Reseñas",
      hours: "Horario",
      location: "Ubicación",
      contact: "Contacto",
    },
    hero: {
      badge: "Empresa Familiar Desde 1985",
      title: "Lopez Appliances",
      subtitle:
        "Refrigeración • Enfriadores • Estufas • Hornos — Reparados por Expertos.",
      cta_call: "Llámenos: (415) 826-8922",
      cta_quote: "Solicitar Cotización",
      scroll: "Desliza",
    },
    services: {
      overline: "Lo Que Reparamos",
      title: "Nuestros Servicios",
      subtitle:
        "Cuatro décadas de experiencia en cada electrodoméstico que mantiene tu hogar en marcha.",
      fridge: {
        title: "Reparación de Refrigeradores",
        desc: "Compresor, termostato, descongelado y máquinas de hielo — diagnóstico el mismo día en la mayoría de modelos.",
      },
      cooler: {
        title: "Reparación de Enfriadores",
        desc: "Enfriadores de vino, bebidas y unidades walk-in — especialistas en sistemas sellados.",
      },
      stove: {
        title: "Reparación de Estufas",
        desc: "Estufas a gas y eléctricas — quemadores, encendedores y placas de control restaurados con precisión.",
      },
      oven: {
        title: "Reparación de Hornos",
        desc: "Resistencias, sensores y sellos de puerta restaurados al rendimiento de fábrica.",
      },
      used: {
        title: "Electrodomésticos Usados en Venta",
        desc: "Electrodomésticos seleccionados y probados a precios honestos — visite nuestra tienda en OfferUp.",
        cta: "Comprar en OfferUp",
      },
    },
    hours: {
      overline: "Cuándo Trabajamos",
      title: "Horario de Atención",
      open_now: "Abierto Ahora",
      closed_now: "Cerrado",
      weekdays: "Lunes – Sábado",
      sunday: "Domingo",
      time_weekdays: "9:00 AM – 5:00 PM",
      time_sunday: "Cerrado",
      days: {
        Mon: "Lunes",
        Tue: "Martes",
        Wed: "Miércoles",
        Thu: "Jueves",
        Fri: "Viernes",
        Sat: "Sábado",
        Sun: "Domingo",
      },
      footnote: "Servicio el mismo día disponible en todo San Francisco.",
    },
    reviews: {
      overline: "Lo Que Dicen los Clientes",
      title: "Reseñas de Google",
      summary: "8 reseñas • 4.4 ★★★★½",
      cta: "Dejar una Reseña",
      list: [
        {
          name: "Willie G. Morris",
          stars: 5,
          text: "San Francisco Heating & Air Conditioning Contractors es excelente. Su técnico fue conocedor, amable y eficiente. Diagnosticó el problema rápidamente y lo arregló el mismo día. Aprecié la honestidad y la comunicación clara. El precio fue muy justo. Realmente ofrece un servicio confiable, y los volveré a llamar sin duda.",
        },
        {
          name: "Luis P. Perez",
          tag: "Guía Local",
          stars: 5,
          text: "Sólo tiendo a escribir reseñas cuando tengo una mala experiencia o una excelente, y esta es la segunda. No puedo recomendar a Ethan lo suficiente para unidades HVAC en edificios de condominios, incluso es perspicaz en termostatos Nest. Me encanta trabajar con ellos.",
        },
        {
          name: "Riley Allen",
          stars: 5,
          text: "El técnico brindó un servicio al cliente excepcional. Respondió pacientemente a todas nuestras preguntas y se aseguró de que entendiéramos el proceso de reparación. ¡Una experiencia verdaderamente agradable y tranquilizadora!",
        },
        {
          name: "Mike Bradford",
          stars: 5,
          text: "Nuestra unidad de HVAC en nuestro espacio de coworking se descompuso durante una ola de calor y vinieron de inmediato. Los hemos llamado varias veces para arreglar otros problemas y siempre nos han dado una respuesta directa y han completado el trabajo a tiempo.",
        },
      ],
    },
    location: {
      overline: "Encuéntranos",
      title: "Nuestra Ubicación",
      address: "3474 Mission Street, San Francisco, CA 94110",
      phone: "(415) 826-8922",
      email: "lopezappliance85@gmail.com",
      cta: "Cómo Llegar",
    },
    offerup: {
      overline: "Usados, Totalmente Probados",
      title: "Compra Nuestros Electrodomésticos Usados",
      desc: "Refrigeradores, lavadoras y secadoras reacondicionados de calidad — inspeccionados por nuestro equipo y listados a precios justos y vecinales en OfferUp.",
      cta: "Ver en OfferUp",
    },
    about: {
      overline: "Nuestra Historia",
      title: "Empresa Familiar Desde 1985.",
      desc: "Cuatro décadas reparando lo que más importa en los hogares de San Francisco — con honestidad, dedicación y trato de vecino.",
      counter_years: "Más de 40 Años",
      counter_repairs: "Miles de Reparaciones",
      counter_rating: "Calificación 5★",
    },
    footer: {
      slogan: "Confianza Familiar Desde 1985.",
      quick_links: "Enlaces Rápidos",
      contact: "Contacto",
      follow: "Síguenos",
      copyright: "© 2026 Lopez Appliances. Empresa Familiar Desde 1985.",
    },
    quote_email: {
      subject: "Solicitud de Cotización - Lopez Appliances",
      body: "Hola Lopez Appliances,\n\nMe gustaría una cotización para [tipo de electrodoméstico].\nMi problema es: [describir].\nMejor contacto: [teléfono/correo].\n\n¡Gracias!",
    },
  },
};

export const SUPPORTED_LANGUAGES = ["en", "es"];
